import Auth from 'sites/utils/Auth';

export const MORE_INFO_ON_WALLET = 'more-info-on-wallet';
export const MORE_INFO_ON_WALLET_TOP_UP = 'more-info-on-wallet-top-up';
export const MORE_INFO_ON_WALLET_AND_FEES = 'more-info-on-wallet-and-fees';
export const MORE_INFO_ON_PAYMENT_DECLINES = 'more-info-on-payment-declines';
export const MEMBER_SUPPORT = 'member-support';
export const CONTACT_SUPPORT = 'contact-support';
export const MEMBER_PAYMENT_FAQS = 'member-payment-faqs';
export const FILE_A_COMPLAINT = 'file-a-complaint';

// const IntercomMoreInfo = (paramValue) => {

// }
const IntercomMoreInfo = (paramValue, otherParams = {}) => {
   const paramName = 'trigger';
   const searchParams = new URLSearchParams(window.location.search);
   searchParams.set(paramName, paramValue);

   if(otherParams) {
      Object.keys(otherParams).forEach(key => searchParams.set(key, otherParams[key]))
   }

   const queryParam = searchParams.toString();
   const currentUrl = window.location.pathname;
   const newUrl = `${ currentUrl }?${ queryParam }`;
   window.history.replaceState({}, '', newUrl);

   if(window.Intercom) {
      setTimeout(() => {
         window.Intercom('show');
         setTimeout(() => {
            let settings = {}
            if(!Auth.isTokenExists() && paramValue === CONTACT_SUPPORT){
               settings = {
                  member_current_page_url: window.location.href,
               }
            }
            window.Intercom('update', settings);
         }, 100);
      }, 100);
   }
}
export default IntercomMoreInfo;
